const DeviceSearchHeaders = [
  {
    label: "GMDN® Code",
    key: "GMDN_CODE",
  },
  {
    label: "GMDN® Term",
    key: "GMDN_TERM_NAME",
  },
  {
    label: "Medical Device Risk Classification",
    key: "DEVICE_SUB_TYPE_DESC",
  },
  {
    label: "Medical Device Names (Brand/Trade names)",
    key: "BRAND_TRADE_NAME",
  },
  {
    label: "Date Registered",
    key: "PRODUCT_CREATED_DATE",
  },
];

export default DeviceSearchHeaders;
